// Generated by scripts/intercom-help-center-migration/gen-help-center-links.mjs — do not edit by hand.
// Regenerate after re-exporting the target workspaces; see that script for the export command.

import type { IHelpCenterLinks } from '../src/getTextThemeProvider';

type MigratedHelpCenter = {
  HelpCenterUrl: string;
  HelpCenterLinks: IHelpCenterLinks;
};

/** Risk Pro help center 5675233 — dev/staging. */
export const RiskProHelpCenterDev: MigratedHelpCenter = {
  HelpCenterUrl: 'https://help.dev.riskpro.solovis.com',
  HelpCenterLinks: {
    INTERCOM_HELP_ALL_HREF: 'https://help.dev.riskpro.solovis.com',
    FACTOR_EXPOSURE_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517200-what-is-factor-exposure-%CE%B2-and-how-is-it-computed',
    FACTOR_CONTRIBUTION_TO_RISK_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517238-what-is-factor-contribution-to-risk-and-how-is-it-computed',
    FACTOR_CONTRIBUTION_TO_RETURN_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517239-what-is-factor-contribution-to-return-and-how-is-it-computed',
    INTERCOM_HELP_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517099-factor-selection-methodology',
    METRIC_DEFINITIONS_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517164-metric-definitions',
    FORECASTS_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517153-forecasting-in-risk-pro',
    DEMO_PORTFOLIO_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517175-demo-portfolio-information',
    DEMO_PRIVATE_PORTFOLIO_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517186-private-asset-demo-portfolio-information',
    STUDIO_FAQ_HREF: '',
    BENCHMARK_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16516859-setting-benchmarks',
    FORECAST_RETURN_DEF_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517164-metric-definitions#h_7c40a1b2d1',
    EXCESS_RETURN_DEF_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517164-metric-definitions#h_0ac30dcc97',
    TRACKING_ERROR_DEF_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517164-metric-definitions#h_3a162c0323',
    INFORMATION_RATIO_DEF_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517164-metric-definitions#h_2d7f1dcb43',
    MAX_UNDERPERFORMANCE_DEF_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517164-metric-definitions#h_3ef7abe0d6',
    HISTORICAL_RISK_STATISTICS_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517199-historical-risk-statistics',
    PORTFOLIO_LAB_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517152-feature-overview-optimization-and-portfolio-lab',
    ADVANCED_SEARCH_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517179-enhanced-data-library-advanced-search-overview-faq',
    HOLDINGS_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517135-feature-overview-holdings',
    VENNCAST_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517104-feature-overview-risk-pro-cast',
    CURRENCY_CONVERSION_ARTICLE_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517231-currency-conversion',
    REBALANCE_STRATEGY_ARTICLE_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16516841-portfolio-rebalancing-frequency',
    INVESTMENT_CORRELATION_TOOL_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517180-investment-correlation-tool',
    FACTOR_LENS_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517103-factor-lens-faq',
    CURRENCY_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517102-which-currencies-does-risk-pro-support',
    PROXY_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16516840-potential-proxies',
    DESMOOTHING_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517156-private-asset-support-overview-desmoothing-of-private-asset-allocations',
    INTERPOLATION_EXTRAPOLATION_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517116-feature-overview-interpolation-and-extrapolation-of-private-asset-allocation',
    WORKSPACE_MANAGEMENT_ARTICLE_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16516838-workspace-management',
    GROWTH_SIMULATOR_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517146-feature-overview-asset-growth-simulator',
    SCENARIO_ANALYSIS_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517132-feature-overview-sensitivity-analysis',
    SENSITIVITY_ANALYSIS_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517132-feature-overview-sensitivity-analysis',
    NOTABLE_PERIODS_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517173-feature-overview-notable-historical-periods',
    CATEGORIES_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517196-categories',
    FACTOR_ALERTS_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517192-factor-lens-tab',
    HISTORICAL_DRAWDOWN_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517176-feature-overview-historical-drawdown-and-rally-scanner',
    ACCESSING_ANALYSES_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517178-save-access-and-export-analyses',
    INVESTMENT_UPLOADER_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517169-investment-navs-uploader-faq',
    RETURNS_UPLOADER_FAQ_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517139-returns-uploader-faq',
    MASTER_PORTFOLIO_ARTICLE_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517077-getting-started-on-risk-pro#constructing-portfolios',
    ADDEPAR_HELP_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517201-addepar-integration-overview',
    COMMON_BENCHMARKS_HELP_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517161-common-benchmarks',
    PORTFOLIO_COMPARISON_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517140-how-can-i-compare-my-portfolio-allocation-changes',
    PRIVATE_ASSET_LAB_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517165-feature-overview-private-asset-lab-beta',
    PEER_GROUP_ANALYSIS_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517187-feature-overview-peer-group-analysis',
    PRIVATE_ASSET_UPLOADER_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517143-faq-uploading-private-asset-data-and-creating-a-private-asset-portfolio-beta',
    PRIVATE_ASSET_CASH_FLOW_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517120-private-asset-support-overview-cash-flow-pacing-model-beta',
    PRIVATE_PERFORMANCE_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517155-private-asset-support-overview-performance-metrics-and-pme-beta',
    PORTFOLIO_CONSTRUCTION_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517069-portfolio-construction-and-configuration',
    STUDIO_REPORT_LAB_AIS_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517129-faq-creating-reports-in-studio-and-report-lab',
    MISSING_INVESTMENTS_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517185-potential-causes-of-deleted-investments',
    PUBLIC_PRIVATE_ASSET_GROWTH_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517145-private-asset-support-overview-total-portfolio-asset-growth-simulation-beta',
    MULTI_PORTFOLIO_UPLOADER_FAQ_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517357-portfolio-builder-faq',
    ANALYSIS_PERIOD_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517167-how-is-the-analysis-period-adjusted',
    HISTORICAL_PORTFOLIOS_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517130-historical-portfolios-faq',
    DESMOOTHING_HELP_HREF:
      'https://help.dev.riskpro.solovis.com/en/articles/16517159-feature-overview-desmoothing-of-private-asset-allocations',
    ADVISORY_FEES_HELP_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517126-setting-advisory-fees',
    TAX_RATE_HELP_HREF: '',
    REDISTRIBUTION_HELP_HREF: 'https://help.dev.riskpro.solovis.com/en/articles/16517181-restricted-data-in-report-lab',
  },
};

/** Risk Pro help center 5673857 — production. */
export const RiskProHelpCenterProd: MigratedHelpCenter = {
  HelpCenterUrl: 'https://help.riskpro.solovis.com',
  HelpCenterLinks: {
    INTERCOM_HELP_ALL_HREF: 'https://help.riskpro.solovis.com',
    FACTOR_EXPOSURE_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526603-what-is-factor-exposure-%CE%B2-and-how-is-it-computed',
    FACTOR_CONTRIBUTION_TO_RISK_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526637-what-is-factor-contribution-to-risk-and-how-is-it-computed',
    FACTOR_CONTRIBUTION_TO_RETURN_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526638-what-is-factor-contribution-to-return-and-how-is-it-computed',
    INTERCOM_HELP_HREF: 'https://help.riskpro.solovis.com/en/articles/16526520-factor-selection-methodology',
    METRIC_DEFINITIONS_HREF: 'https://help.riskpro.solovis.com/en/articles/16526571-metric-definitions',
    FORECASTS_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526561-forecasting-in-risk-pro',
    DEMO_PORTFOLIO_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526579-demo-portfolio-information',
    DEMO_PRIVATE_PORTFOLIO_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526591-private-asset-demo-portfolio-information',
    STUDIO_FAQ_HREF: '',
    BENCHMARK_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526330-setting-benchmarks',
    FORECAST_RETURN_DEF_HREF: 'https://help.riskpro.solovis.com/en/articles/16526571-metric-definitions#h_7c40a1b2d1',
    EXCESS_RETURN_DEF_HREF: 'https://help.riskpro.solovis.com/en/articles/16526571-metric-definitions#h_0ac30dcc97',
    TRACKING_ERROR_DEF_HREF: 'https://help.riskpro.solovis.com/en/articles/16526571-metric-definitions#h_3a162c0323',
    INFORMATION_RATIO_DEF_HREF: 'https://help.riskpro.solovis.com/en/articles/16526571-metric-definitions#h_2d7f1dcb43',
    MAX_UNDERPERFORMANCE_DEF_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526571-metric-definitions#h_3ef7abe0d6',
    HISTORICAL_RISK_STATISTICS_HREF: 'https://help.riskpro.solovis.com/en/articles/16526602-historical-risk-statistics',
    PORTFOLIO_LAB_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526560-feature-overview-optimization-and-portfolio-lab',
    ADVANCED_SEARCH_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526584-enhanced-data-library-advanced-search-overview-faq',
    HOLDINGS_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526549-feature-overview-holdings',
    VENNCAST_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526528-feature-overview-risk-pro-cast',
    CURRENCY_CONVERSION_ARTICLE_HREF: 'https://help.riskpro.solovis.com/en/articles/16526632-currency-conversion',
    REBALANCE_STRATEGY_ARTICLE_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526289-portfolio-rebalancing-frequency',
    INVESTMENT_CORRELATION_TOOL_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526585-investment-correlation-tool',
    FACTOR_LENS_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526527-factor-lens-faq',
    CURRENCY_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526525-which-currencies-does-risk-pro-support',
    PROXY_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526285-potential-proxies',
    DESMOOTHING_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526565-private-asset-support-overview-desmoothing-of-private-asset-allocations',
    INTERPOLATION_EXTRAPOLATION_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526535-feature-overview-interpolation-and-extrapolation-of-private-asset-allocation',
    WORKSPACE_MANAGEMENT_ARTICLE_HREF: 'https://help.riskpro.solovis.com/en/articles/16526281-workspace-management',
    GROWTH_SIMULATOR_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526557-feature-overview-asset-growth-simulator',
    SCENARIO_ANALYSIS_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526546-feature-overview-sensitivity-analysis',
    SENSITIVITY_ANALYSIS_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526546-feature-overview-sensitivity-analysis',
    NOTABLE_PERIODS_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526578-feature-overview-notable-historical-periods',
    CATEGORIES_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526600-categories',
    FACTOR_ALERTS_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526597-factor-lens-tab',
    HISTORICAL_DRAWDOWN_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526580-feature-overview-historical-drawdown-and-rally-scanner',
    ACCESSING_ANALYSES_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526583-save-access-and-export-analyses',
    INVESTMENT_UPLOADER_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526278-investment-navs-uploader-faq',
    RETURNS_UPLOADER_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526553-returns-uploader-faq',
    MASTER_PORTFOLIO_ARTICLE_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526347-getting-started-on-risk-pro#constructing-portfolios',
    ADDEPAR_HELP_HREF: 'https://help.riskpro.solovis.com/en/articles/16526604-addepar-integration-overview',
    COMMON_BENCHMARKS_HELP_HREF: 'https://help.riskpro.solovis.com/en/articles/16526569-common-benchmarks',
    PORTFOLIO_COMPARISON_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526554-how-can-i-compare-my-portfolio-allocation-changes',
    PRIVATE_ASSET_LAB_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526572-feature-overview-private-asset-lab-beta',
    PEER_GROUP_ANALYSIS_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526592-feature-overview-peer-group-analysis',
    PRIVATE_ASSET_UPLOADER_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526555-faq-uploading-private-asset-data-and-creating-a-private-asset-portfolio-beta',
    PRIVATE_ASSET_CASH_FLOW_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526537-private-asset-support-overview-cash-flow-pacing-model-beta',
    PRIVATE_PERFORMANCE_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526564-private-asset-support-overview-performance-metrics-and-pme-beta',
    PORTFOLIO_CONSTRUCTION_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526332-portfolio-construction-and-configuration',
    STUDIO_REPORT_LAB_AIS_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526544-faq-creating-reports-in-studio-and-report-lab',
    MISSING_INVESTMENTS_FAQ_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526590-potential-causes-of-deleted-investments',
    PUBLIC_PRIVATE_ASSET_GROWTH_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526556-private-asset-support-overview-total-portfolio-asset-growth-simulation-beta',
    MULTI_PORTFOLIO_UPLOADER_FAQ_HREF: 'https://help.riskpro.solovis.com/en/articles/16526552-portfolio-builder-faq',
    ANALYSIS_PERIOD_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526573-how-is-the-analysis-period-adjusted',
    HISTORICAL_PORTFOLIOS_HELP_HREF: 'https://help.riskpro.solovis.com/en/articles/16526545-historical-portfolios-faq',
    DESMOOTHING_HELP_HREF:
      'https://help.riskpro.solovis.com/en/articles/16526566-feature-overview-desmoothing-of-private-asset-allocations',
    ADVISORY_FEES_HELP_HREF: 'https://help.riskpro.solovis.com/en/articles/16526543-setting-advisory-fees',
    TAX_RATE_HELP_HREF: '',
    REDISTRIBUTION_HELP_HREF: 'https://help.riskpro.solovis.com/en/articles/16526586-restricted-data-in-report-lab',
  },
};
